import { render, staticRenderFns } from "./NotificationsCollection.vue?vue&type=template&id=0cd8cb9f&"
import script from "./NotificationsCollection.vue?vue&type=script&lang=js&"
export * from "./NotificationsCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports